import type { ButtonHTMLAttributes } from "react";
import clsx from "clsx";

// Plain button with plain Tailwind v3 classes: catalyst's solid <Button> is
// written for Tailwind v4 (`bg-(--btn-border)`, `data-disabled:`), which this
// app's Tailwind v3 build does not generate, so it renders white text on no
// background. Disabled stays visibly disabled but readable.
const classes =
  "inline-flex min-h-11 items-center justify-center rounded-lg px-4 py-2 text-base font-semibold sm:text-sm " +
  "bg-blue-600 text-white hover:bg-blue-500 " +
  "disabled:cursor-not-allowed disabled:bg-zinc-200 disabled:text-zinc-500 disabled:hover:bg-zinc-200";

/** The main (confirm) button of the dialogs in this folder. */
export default function ConfirmButton({
  className,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement>) {
  return <button type="button" className={clsx(classes, className)} {...props} />;
}
